import { jsx as t, jsxs as l, Fragment as x } from "react/jsx-runtime";
import { memo as g, useState as v, useEffect as w } from "react";
import { Portal as y } from "../Portal/index.js";
import { Skeleton as b } from "antd";
import { useSimpleModal as D } from "./hooks.js";
import { R as k } from "../../../CloseOutlined-CEtTmi9p.js";
const C = ({
  width: s = 1600,
  title: n = "",
  children: c,
  footer: m = null,
  className: f = "pc-media-library",
  onCancel: a,
  zIndex: d = 2e3,
  opacity: r = 0,
  pointerEvents: p = "none",
  destroyOnHidden: u = !1
}) => {
  const [i, h] = v(!1), o = r === 1;
  return w(() => {
    const e = setTimeout(() => {
      o && h(!0);
    }, 700);
    return () => clearTimeout(e);
  }, [o]), u && !o ? null : /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t(
    "div",
    {
      style: {
        contain: "strict",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: d,
        opacity: r,
        pointerEvents: p,
        transition: "opacity 0.3s ease-out",
        willChange: "opacity"
      },
      onClick: (e) => {
        e.stopPropagation(), e.preventDefault(), e.target === e.currentTarget && a && a();
      },
      children: /* @__PURE__ */ l(
        "div",
        {
          style: {
            position: "relative",
            width: `${s}px`,
            maxWidth: "max(90%, calc(100vw - 4rem))",
            backgroundColor: "#ffffff",
            padding: "2rem",
            borderRadius: "1rem"
          },
          className: f,
          children: [
            /* @__PURE__ */ l("div", { className: "at-px-4 at-absolute at-top-4 at-left-0 at-w-full at-h-8 at-flex at-items-center at-justify-between", children: [
              /* @__PURE__ */ t("div", { className: "at-font-semibold at-text-lg at-ml-4", children: n }),
              /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
                k,
                {
                  onClick: a,
                  className: "at-text-2xl at-text-gray-700 at-cursor-pointer"
                }
              ) })
            ] }),
            !i && /* @__PURE__ */ t(b, { active: !0, className: "at-my-8" }),
            i && /* @__PURE__ */ t(x, { children: /* @__PURE__ */ t("div", { className: "at-h-fit at-max-h-[calc(100vh-20rem)] at-my-8 at-overflow-auto at-pr-2", children: c }) }),
            /* @__PURE__ */ t("div", { className: "at-px-4 at-absolute at-bottom-2 at-left-0 at-w-full at-h-12 at-flex at-flex-row-reverse at-items-center at-justify-between", children: m })
          ]
        }
      )
    }
  ) });
}, B = g(C);
export {
  B as SimpleModal,
  D as useSimpleModal
};
